var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"type":"unknown","icon":"block-unknown","id":9999999999,"collections":[],"show-controls":false,"searchable":false}},[_c('p',{staticClass:"mt-2 text-supplement"},[_vm._v("Uknown Block")])])}
var staticRenderFns = []

export { render, staticRenderFns }